import { render } from "./SearchResults.vue?vue&type=template&id=a90ee782&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=a90ee782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90ee782"]])

export default __exports__